import type { Distance } from "../units/Units"
import type { SpatialRectangle } from "./SpatialRectangle"

export type Media = {
  readonly trim_box: SpatialRectangle<Distance>
  readonly media_box: SpatialRectangle<Distance>
}
